import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/thumbs";

import {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Thumbs,
} from "swiper/modules";

// Register all modules globally
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);

// === Page Header Slider ===
if (document.querySelector(".header-swiper")) {
  const headerSwiper = new Swiper(".header-swiper", {
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    cssEase: "linear",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      slideChangeTransitionStart: function () {
        // Prepare the next video during transition
        console.log("Transition starting to index:", this.activeIndex);
        prepareNextVideo(this);
      },
      slideChangeTransitionEnd: function () {
        // Clean up after transition completes
        console.log("Transition ended, cleaning up");
        cleanupInactiveVideos(this);
      },
      init: function () {
        console.log("Swiper initialized");
        // Set up all videos initially
        setupVideos(this);
        // Play the first video
        playActiveVideo(this);
      },
    },
  });

  function setupVideos(swiper) {
    // Preload all videos and set them to loop
    const allVideos = document.querySelectorAll(".slide-media-video");
    allVideos.forEach((video) => {
      video.loop = true; // Enable looping for continuous playback
      video.muted = true; // Ensure videos are muted for autoplay
      video.playsInline = true; // Important for mobile
      video.preload = "auto"; // Preload videos
    });
  }

  function prepareNextVideo(swiper) {
    // Get the slide that's about to become active
    const nextSlide = swiper.slides[swiper.activeIndex];
    const nextVideo = nextSlide
      ? nextSlide.querySelector(".slide-media-video")
      : null;

    if (nextVideo) {
      // Start playing the next video during the fade transition
      console.log("Preparing next video");
      nextVideo.currentTime = 0;
      nextVideo.play().catch((e) => {
        console.log("Video play failed:", e);
      });
    }
  }

  function cleanupInactiveVideos(swiper) {
    // Only pause videos that are not in the active slide
    const allSlides = swiper.slides;

    allSlides.forEach((slide, index) => {
      if (index !== swiper.activeIndex) {
        const video = slide.querySelector(".slide-media-video");
        if (video) {
          console.log("Pausing inactive video at index:", index);
          video.pause();
          // Don't reset currentTime here to avoid jarring restarts
        }
      }
    });
  }

  function playActiveVideo(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlide
      ? activeSlide.querySelector(".slide-media-video")
      : null;

    if (activeVideo) {
      console.log("Playing active video");
      activeVideo.currentTime = 0;
      activeVideo.play().catch((e) => {
        console.log("Video play failed:", e);
      });
    }
  }

  // Optional: Handle visibility changes to pause/resume videos
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      // Pause all videos when page is hidden
      document.querySelectorAll(".slide-media-video").forEach((video) => {
        video.pause();
      });
    } else {
      // Resume the active video when page is visible
      playActiveVideo(headerSwiper);
    }
  });
}

// === Gallery with Thumbnails ===
if (document.body.classList.contains("single-availability")) {
  const availabilitySwiperNav = new Swiper(".availability-swiper-nav", {
    slidesPerView: "auto",
    spaceBetween: 15,
    watchSlidesProgress: true,
  });

  const availabilitySwiper = new Swiper(".availability-swiper", {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: availabilitySwiperNav,
    },
  });

  if (availabilitySwiper.slides.length <= 1) {
    const nextBtn = document.querySelector(".swiper-button-next");
    const prevBtn = document.querySelector(".swiper-button-prev");
    const thumbNav = document.querySelector(".availability-swiper-nav-wrap");

    if (nextBtn) nextBtn.style.display = "none";
    if (prevBtn) prevBtn.style.display = "none";
    if (thumbNav) thumbNav.style.display = "none";
  }
}
